"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Resource = void 0;

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _wrapNativeSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/wrapNativeSuper"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ResourceError = /*#__PURE__*/function (_Error) {
  (0, _inherits2.default)(ResourceError, _Error);

  var _super = _createSuper(ResourceError);

  function ResourceError(message) {
    var _this;

    (0, _classCallCheck2.default)(this, ResourceError);
    _this = _super.call(this, message);
    _this.name = 'ResourceError';
    return _this;
  }

  return (0, _createClass2.default)(ResourceError);
}( /*#__PURE__*/(0, _wrapNativeSuper2.default)(Error));
/**
 *  Resource class
 *  The react suspense API might change in the future.
 *  Refer to https://reactjs.org/docs/concurrent-mode-suspense.html from API changes
 */


var Resource = /*#__PURE__*/function () {
  function Resource(getter, setter) {
    (0, _classCallCheck2.default)(this, Resource);
    this.getter = void 0;
    this.setter = void 0;
    this.resource = undefined;
    this.error = undefined;
    this.status = 'unprepared';
    this.suspender = undefined;
    this.getter = getter;
    this.setter = setter;
  }

  (0, _createClass2.default)(Resource, [{
    key: "suspendPromise",
    value: function suspendPromise(promise) {
      var _this2 = this;

      return promise.then(function (r) {
        _this2.status = 'success';
        _this2.resource = r;
      }, function (e) {
        _this2.status = 'error';
        _this2.error = e;
      });
    }
  }, {
    key: "prepare",
    value: function prepare(optimistic) {
      if (this.status === 'unprepared' || typeof this.suspender === 'undefined') {
        if (typeof optimistic === 'undefined') {
          this.suspender = this.suspendPromise(this.getter());
          this.status = 'pending';
        } else {
          this.suspender = Promise.resolve();
          this.status = 'success';
          this.resource = optimistic;
        }
      }

      return this;
    }
  }, {
    key: "prepareAsUndefined",
    value: function prepareAsUndefined() {
      if (this.status === 'unprepared' || typeof this.suspender === 'undefined') {
        this.suspender = Promise.resolve();
        this.status = 'success';
        this.resource = undefined;
      }

      return this;
    }
  }, {
    key: "fetchResource",
    value: function fetchResource() {
      return this.getter();
    }
  }, {
    key: "setLocalResource",
    value: function setLocalResource(newResource) {
      this.resource = newResource;
      this.status = 'success';
    }
  }, {
    key: "setResource",
    value: function setResource(newResource) {
      var _this3 = this;

      if (typeof this.setter === 'undefined') {
        throw new ResourceError('Attempted to set resource but no setter was defined. Did you mean to "setLocalResource" instead?');
      }

      var oldResource = typeof this.resource === 'undefined' ? undefined : JSON.parse(JSON.stringify(this.resource));
      this.setLocalResource(newResource);
      return this.setter(newResource).catch(function (error) {
        // It the remote rejects the call, we reset this resources state
        _this3.resource = oldResource;
        throw error;
      });
    }
  }, {
    key: "getSuspenderRef",
    value: function getSuspenderRef() {
      if (this.status === 'unprepared' || typeof this.suspender === 'undefined') {
        throw new ResourceError('Cannot get suspender ref, since resource was not initialized. Make sure to call prepare on the resource before reading it!');
      }

      return this.suspender;
    }
    /**
     * Experimental suspender
     * The react suspense API might change in the future.
     * Refer to https://reactjs.org/docs/concurrent-mode-suspense.html from API changes
     * This "suspencyfies" the promise by throwing it, if it has not yet resolved and returning its result, if it did.
     *
     * @returns {T}             the resource
     * @throws  {Promise<void>} the suspender
     */

  }, {
    key: "read",
    value: function read() {
      if (this.status === 'unprepared' || typeof this.suspender === 'undefined') {
        throw new ResourceError('Resource was read before it was initialized. Make sure to call prepare on the resource before reading it!');
      } else if (this.status === 'pending') {
        throw this.suspender;
      } else if (this.status === 'success') {
        return this.resource;
      } else {
        throw this.error;
      }
    }
  }]);
  return Resource;
}();

exports.Resource = Resource;